import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { THEME_COLORS } from '../components/Constants';

export default function LegalPage({ title, content }) {
    const navigate = useNavigate();
    const { currentTheme } = useTheme();
    const colors = THEME_COLORS[currentTheme];

    return (
        <div style={styles.container}>
            <button onClick={() => navigate(-1)} style={{...styles.backBtn, color: colors.primary}}>← Retour</button>
            <h1 style={{borderBottom: `3px solid ${colors.primary}`, paddingBottom: '10px'}}>{title}</h1>
            <div style={styles.content}>
                {content}
            </div>
        </div>
    );
}

const styles = {
    container: { padding: '40px 10%', maxWidth: '900px', margin: '0 auto', backgroundColor: '#fff', minHeight: '100vh' },
    backBtn: { background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold', marginBottom: '20px' },
    content: { lineHeight: '1.6', color: '#444', whiteSpace: 'pre-line' } // conserve les retours à la ligne
};